import React, { useState, useEffect } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import Carousel from 'react-bootstrap/Carousel';

import '../AILens/AiLens.css'

import { ReadMoreButton } from '../ExtraComponents/ReadMoreButton'
import { CarousalComponent } from '../CarousalComponent/CarousalComponent'
import { ValidForm } from '../ContactForm/ValidForm'
import { CarouselComponent } from '../CarouselForWebsite/CarouselComponent'

export const SPIR = () => {
 return (
        <div>
            <section className='Ai-Lens-top'>
                <Container className=''>
                    <Row style={{ alignItems: 'center' }}>
                        <Col lg={7}>
                            <div className='AiLens-heading'>
                                <h1>Spare Parts Interchangeability Record (iSPIR)</h1>
                                <p>Over 6000+ Unique templates for Material, Equipment and Service Master Records.
                                ISO 8000 compliant data models and structures</p>

                            </div>
                        </Col>
                        <Col lg={5}>
                            <div className="rightBannersection">
                                <img width='100%' src={require("../Assets/AiLens/AILens.png")} alt='Ai-hero-img' loading='lazy' />
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

           

            <section className='Ai-Lens-section2'>
                <Container>
                    <Row>
                        <Col lg={8}>
                            <div className='empty-div'></div>
                            <div className='Pilogs-copilot'>
                                <h2 className='text-start'>SPIR Template</h2>
                               
                            </div>
                        </Col>
                        <Col lg={6}>
                            <div className='key-aspect-section mt-4'>
                              

                                <Row className='my-1 p-1 '>
                                    <Col lg={6} className='my-2'>
                                        <div className='d-flex gap-2 '>
                                            <img className='Ai-lens-conceived' src={require("../Assets/AiLens/AILens_Icons/Conversational AI​_Icon.png")} alt="ldg-key-aspects" loading="lazy" />
                                            <p style={{ fontSize: '14px' }}>Parent Equipment Tag/Model/Serial Number​</p>
                                        </div>
                                    </Col>
                                    <Col lg={6} className='my-2'>
                                        <div className='d-flex gap-2  '>
                                            <img className='Ai-lens-conceived' src={require("../Assets/AiLens/AILens_Icons/Scaled down LLM Model_Icon.png")} alt="ldg-key-aspects" loading="lazy" />
                                            <p style={{ fontSize: '14px' }}>Installed number of Spares</p>
                                        </div>
                                    </Col>
                                    <Col lg={6} className='my-2'>
                                        <div className='d-flex gap-2 '>
                                            <img className='Ai-lens-conceived' src={require("../Assets/AiLens/AILens_Icons/Generative AI Approach_Icon.png")} alt="ldg-key-aspects" loading="lazy" />
                                            <p style={{ fontSize: '14px' }}>Spare Part Description</p>
                                        </div>
                                    </Col>
                                    <Col lg={6} className='my-2'>
                                        <div className='d-flex gap-2 '>
                                            <img className='Ai-lens-conceived' src={require("../Assets/AiLens/AILens_Icons/Trained Contextually_Icon.png")} alt="ldg-key-aspects" loading="lazy" />
                                            <p style={{ fontSize: '14px' }}>SPIR Number</p>
                                        </div>
                                    </Col>
                                    <Col lg={6} className='my-2'>
                                        <div className='d-flex gap-2 '>
                                            <img className='Ai-lens-conceived' src={require("../Assets/AiLens/AILens_Icons/N​​LP Model​_icon.png")} alt="ldg-key-aspects" loading="lazy" />
                                            <p style={{ fontSize: '14px' }}>Equipment Supplier & Manufacturer details​</p>
                                        </div>
                                    </Col>
                                    <Col lg={6} className='my-2'>
                                        <div className='d-flex gap-2 '>
                                            <img className='Ai-lens-conceived' src={require("../Assets/AiLens/AILens_Icons/Knowledge Base_Icon.png")} alt="ldg-key-aspects" loading="lazy" />
                                            <p style={{ fontSize: '14px' }}>Knowledge Base</p>
                                        </div>
                                    </Col>
                                    <Col lg={6} className='my-2'>
                                        <div className='d-flex gap-2'>
                                            <img className='Ai-lens-conceived' src={require("../Assets/AiLens/AILens_Icons/Augmented AI_icon.png")} alt="ldg-key-aspects" loading="lazy" />
                                            <p style={{ fontSize: '14px' }}>Price</p>
                                        </div>
                                    </Col>
                                    {/* <Col lg={6} className='my-2'>
                                        <div className='d-flex gap-2 '>
                                            <img className='Ai-lens-conceived' src={require("../Assets/AiLens/AILens_Icons/Configurable Features​​_Icon.png")} alt="ldg-key-aspects" loading="lazy" />
                                            <p style={{ fontSize: '14px' }}>Configurable Features​​</p>
                                        </div>
                                    </Col>
                                    <Col lg={6} className='my-2'>
                                        <div className='d-flex gap-2 align-items-center text-start'>
                                            <img className='Ai-lens-conceived' src={require("../Assets/AiLens//AILens_Icons/Simple & Extended Analytics​_Icon.png")} alt="ldg-key-aspects" loading="lazy" />
                                            <p style={{ fontSize: '14px' }}>Simple & Extended
                                                Analytics​</p>
                                        </div>
                                    </Col>
                                    <Col lg={6} className='my-2'>
                                        <div className='d-flex gap-2 align-items-center text-start'>
                                            <img className='Ai-lens-conceived' src={require("../Assets/AiLens/AILens_Icons/Real time & Staged Integration with SAP or Oracle or APIs​_Icon.png")} alt="ldg-key-aspects" loading="lazy" />
                                            <p style={{ fontSize: '14px' }}>Real time & Staged Integration with SAP or Oracle or APIs​</p>
                                        </div>
                                    </Col>
                                    <Col lg={6} className='my-2'>
                                        <div className='d-flex gap-2 align-items-center text-start'>
                                            <img className='Ai-lens-conceived' src={require("../Assets/AiLens/AILens_Icons/Guide as Subject Matter Expert​_Icon.png")} alt="ldg-key-aspects" loading="lazy" />
                                            <p style={{ fontSize: '14px' }}>Guide as Subject Matter
                                                Expert​</p>
                                        </div>
                                    </Col>
                                    <Col lg={6} className='my-2'>
                                        <div className='d-flex gap-2 align-items-center text-start'>
                                            <img className='Ai-lens-conceived' src={require("../Assets/AiLens/AILens_Icons/Qualitative Validations & more​​_Icon.png")} alt="ldg-key-aspects" loading="lazy" />
                                            <p style={{ fontSize: '14px' }}>Qualitative Validations & more​​</p>
                                        </div>
                                    </Col> */}

                                </Row>



                            </div>
                        </Col>
                        <Col lg={6}>
                            <div className='key-aspect-images'>
                                <img className='image-1' src={require("../Assets/AiLens/AI-Img.png")} alt="ldg-key-aspects" loading="lazy" />
                                {/* <img className='image-gif' src={require("../Assets/LDG/cloud_icon.gif")} alt="ldg-key-aspects-cloud" /> */}

                            </div>

                        </Col>
                    </Row>
                </Container>

            </section>

            <section className='explore-ailens'>
                <Container>
                    <Row className='mt-4'>
                        <Col lg={5}>

                            <div>
                                <img className='w-100' src={require("../Assets/AiLens/Group.png")} alt="group" loading="lazy" />
                            </div>
                        </Col>
                        <Col lg={7}>
                        <div className='empty-div'></div>
                            <div className='explore-ailens-heading'>
                                <h2>The Challenge</h2>
                            </div>
                            <div className='border shadow-sm  rounded p-2 my-2 text-start'>
                                
                                <Row>
                                    <Col>
                                        <div>
                                            <ul className='explore-topics'>
                                                <li>Creation of Spares Management Guidelines, Procedures, and Governance.</li>
                                               
                                            </ul>

                                        </div>
                                    </Col>
                                   
                                </Row>
                            </div>
                            <div className='border shadow-sm rounded p-2 my-2 text-start'>
                                <h6>Identification of</h6>
                                <Row>
                                    <Col>
                                        <div>
                                            <ul className='explore-topics'>
                                            <li>Equipment or Asset that requires Spares</li>
                                                <li>Equipment Type Spares requirements.</li>
                                                <li>Spares documentation requirements.</li>
                                            </ul>

                                        </div>
                                    </Col>
                                   
                                </Row>
                            </div>


                            <div className='border shadow-sm rounded p-2 my-2 text-start'>
                         
                                <Row>
                                    <Col>
                                        <div>
                                            <ul className='explore-topics'>
                                                <li>Electronic upload of Spares Master Data from different sources and in different formats.</li>
                                                
                                            </ul>

                                        </div>
                                    </Col>
                                  
                                </Row>
                            </div>

                            <div className='border shadow-sm rounded p-1 my-2 text-start'>
                                
                                <Row>
                                    <Col>
                                        <div>
                                            <ul className='explore-topics'>
                                            <li>Controlling and online visibility of Spares Spend concerning Capital expenditure.</li>
                                            </ul>

                                        </div>
                                    </Col>
                                   
                                </Row>
                            </div>
                           
                        </Col>

                    </Row>
                </Container>
            </section>

            <section className='explore-ailens'>
                <Container>
                    <Row className='mt-4'>
                    <div className='empty-div'></div>
                            <div className='explore-ailens-heading'>
                                <h2>Benefits</h2>
                            </div>
                    <Col lg={6}>
                        
                            <div className='border shadow-sm  rounded p-2 my-2 text-start'>
                            <h6>Client Resource Cost reductions</h6>
                                <Row>
                                    <Col>
                                        <div>
                                            <ul className='explore-topics'>
                                                <li>Supplier/Contractor registers spares online</li>
                                               <li>Electronic workflow cuts time to process</li>
                                               <li>Interface to ERP cuts registration time</li>
                                               <li>Spares linked to Plant Equipment cuts the searching time of Plant Maintenance personnel</li>
                                            </ul>

                                        </div>
                                    </Col>
                                   
                                </Row>
                            </div>
                            <div className='border shadow-sm rounded p-2 my-2 text-start'>
                                <h6>Warehousing Cost reductions</h6>
                                <Row>
                                    <Col>
                                        <div>
                                            <ul className='explore-topics'>
                                            <li>Duplicate Resolution optimizes warehouse layout and size</li>
                                                <li>Warehouse personnel spend less time searching for spares, hence become more productive</li>
                                                <li>Identification of common spares between plants can cut possible delivery time on critical spares</li>
                                            </ul>

                                        </div>
                                    </Col>
                                   
                                </Row>
                            </div>


                           
                        </Col>
                        <Col lg={6}>
                       
                           
                            <div className='border shadow-sm  rounded p-2 my-2 text-start'>
                                <h6>Procurement Cost reductions</h6>
                                <Row>
                                    <Col>
                                        <div>
                                            <ul className='explore-topics'>
                                                <li>Electronic verification of spares against existing Catalogue allows a reduction in procurement quantities.</li>
                                                <li>Allows for inventory optimization that cuts replenishment costs.</li>
                                                <li>Cross-referencing of spares allows for optimization of preferred Vendors, improving bargaining power</li>
                                                <li>If Plant Maintenance finds spares due to improved descriptions and links, reduction in ad-hoc purchasing can be expected.</li>
                                                <li>Improved spend analysis allows for Procurement to concentrate on problem processes and Vendors</li>
                                                                                              
                                            </ul>

                                        </div>
                                    </Col>
                                   
                                </Row>
                            </div>
                            <div className='border shadow-sm rounded p-2 my-2 text-start'>
                                <h6>Plant Maintenance Cost reductions</h6>
                                <Row>
                                    <Col>
                                        <div>
                                            <ul className='explore-topics'>
                                            <li>Less downtime due to spares unavailability</li>
                                                <li>Equipment Type Spares requirements.</li>
                                                <li>Spares documentation requirements.</li>
                                            </ul>

                                        </div>
                                    </Col>
                                   
                                </Row>
                            </div>


                        </Col>
                    </Row>
                </Container>
            </section>

            <section className='my-5'>
                <Container>
                    <div>
                        <h2 className='text-center text-primary'>Functionality</h2>
                    </div>
                    <CarouselComponent/>
                </Container>
            </section>



         

            <section>
                <Container className='d-flex justify-content-center align-items-center text-align-center'>
      <img className='w-75 ' src='https://piloggroup.com/img/Products/ispir/slide6.png' alt='Use-Case-5' loading="lazy" />
                    
                </Container>
            </section>

    
        </div>
    )
}
